import { injectable } from "inversify";
import * as THREE from "three";
import { type IService, Logger } from "@designboticteam/core";
import { MainScene } from "./MainScene";

@injectable()
class SceneService implements IService {
	readonly serviceName = "🎭 SceneService";
	private logger = new Logger(`🎬 WORKSPACE 3D | ${this.serviceName}`, {
		color: "#ffffff",
		backgroundColor: "#0066cc",
	});

	#scene: MainScene | null = null;
	public get scene(): MainScene {
		if (this.#scene === null) {
			throw new Error("Scene not initialized.");
		}

		return this.#scene;
	}

	constructor() {
		this.logger.log(`constructed`);
	}

	public initialize(): void {
		this.#scene = new MainScene();
		this.scene.initialize();
		this.logger.log(`initialized`);
	}

	public update(): void {
		this.scene.update();
	}

	public dispose() {
		this.scene.clear();
		this.#scene = null;
		this.logger.log(`disposed`);
	}

	// export interface SceneObject {
	// 	id: string;
	// 	object: THREE.Object3D;
	// 	type: "mesh" | "light" | "helper" | "polyline" | "group";
	// 	metadata?: Record<string, any>;
	// }
	public addObject(sceneObject: THREE.Object3D): string {
		const uuid = crypto.randomUUID();
		// const sceneObject: SceneObject = {
		// 	id,
		// 	object,
		// 	type,
		// 	metadata,
		// };

		// this.objectRegistry.set(id, sceneObject);

		// Add edge overlay for meshes
		sceneObject.traverse((obj) => {
			if (obj instanceof THREE.Mesh) {
				// SceneUtils.ShowStructuralEdges(o, this.materialService);
			}
		});

		this.scene.add(sceneObject);

		// this.visibilityService.register(id, true);
		// object.visible = this.visibilityService.isVisible(id);

		// const typeGroup = this.typeGroups.get(type);
		// if (typeGroup) {
		// 	typeGroup.add(id);
		// 	this.visibilityService.createGroup(type, Array.from(typeGroup));
		// }

		// Update stats and log action
		// this.updateSceneStats();
		// this.storeService.logAction(`Added ${type} object: ${id}`);

		return uuid;
	}
}

export { SceneService };
